import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './AdminUploadFolder.css';

const ADMIN_ROOT = process.env.REACT_APP_START_PATH || '/admin';

function AdminUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={ADMIN_ROOT}
      sessionPrefix="admin_folder"
    />
  );
}

AdminUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default AdminUploadFolder;
